import { render } from "./Compras.vue?vue&type=template&id=15a070be"
import script from "./Compras.vue?vue&type=script&lang=js"
export * from "./Compras.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/rpasii/Compras.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15a070be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15a070be', __exports__)) {
    api.reload('15a070be', __exports__)
  }
  
  module.hot.accept("./Compras.vue?vue&type=template&id=15a070be", () => {
    api.rerender('15a070be', render)
  })

}


export default __exports__